// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { Redirect } from 'react-router-dom';
import { useCurrentUser } from '@Queries/userQueries';
import RouteBuilder from '@Services/RouteBuilder';
import { ADMIN_ORG_ID } from '@Types';
import { findDefaultPath } from '@Helpers/RedirectPath';
import useLocalStorage, { LocalStorageKeys } from '@Hooks/useLocalStorage';

const AdminRedirect = (path: string) => <Redirect to={RouteBuilder.compute(path as any)} />;
const UserRedirect = <Redirect to={RouteBuilder.compute('cases.default')} />;
const LoginRedirect = <Redirect to={RouteBuilder.compute('login.default')} />;

const UnknownRoute = (): ReactElement => {
    const { storage } = useLocalStorage<{ homepage: string }>({
        key: LocalStorageKeys.OPTIONS,
        initialValue: { homepage: RouteBuilder.compute('cases.default') },
    });

    const { data } = useCurrentUser();

    if (data) {
        const { permissions = [] as string[] } = data;
        const isUserAdmin = data.organisation === ADMIN_ORG_ID;
        if (isUserAdmin && permissions) {
            const defaultPath = findDefaultPath(permissions);
            if (defaultPath) {
                return AdminRedirect(defaultPath);
            }
        }
        return storage.homepage ? <Redirect to={storage.homepage} /> : UserRedirect;
    }
    return LoginRedirect;
};

export default UnknownRoute;
